import * as React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import ConsumerAssetOverview from '../../consumer/pages/ConsumerAssetOverview';
import Error from './Error';
import Expired from './Expired';
import Dashboard from './Dashboard';
import ProviderAssetOverview from '../../provider/pages/ProviderAssetOverview';
import ProviderAssets from '../../provider/pages/ProviderAssets';
import Subscriptions from '../../consumer/pages/Subscriptions';
import NavSide from '../components/nav-side/NavSide';
import NavTop from '../components/nav-top/NavTop';
import Verifications from '../../subscription/pages/Verifications'
import Verification from '../../subscription/pages/Verification';
import PendingSubscriptions from '../../subscription/pages/PendingSubscriptions';
import AssetSubscriptions from '../../subscription/pages/AssetSubscriptions'
import VerificationHistory from '../../subscription/pages/VerificationsHistory';
import Billing from '../../billing/pages/Billing';
import HttpService from '../services/HttpService';
import OrganizationOverview from '../../organization/pages/OrganizationOverview';
import SubscribeRequestConfirm from '../../subscription/pages/SubscribeRequestConfirm';
import TermsAndConditionsForm from './TermsAndConditionsForm';
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import CssBaseline from '@material-ui/core/CssBaseline';
import { Snackbar, Drawer, Hidden } from '@material-ui/core';
import { StyleRulesCallback, withStyles } from '@material-ui/core/styles';
import { closeFeedbackMessageAction } from '../actions/actions';
import { loadCommunityOwnerships, loadCommunityOwnershipsSuccess } from '../actions/communitiesActions';
import store from "../store";
import ValidationSnackbarContentWrapper from '../../shared/components/ValidationSnackbarContentWrapper';
import MyProfile from '../../core/pages/MyProfile';
import Subscribe from '../../subscription/pages/Subscribe';
import OrganizationUser from '../../organization/models/OrganizationUser';
import history from '../../../history/browserHistory';
import { identity, isAdmin as userIsAdmin} from '../auth/identityAuth';
import './App.css';
import BillingAdressForm from './BillingAdressForm';
import Address from "../../organization/models/Address";
import Entity from "../../organization/models/Entity";
import { AddressTypeIds } from "../../shared/constants";
import RequestCommunityMembership from "../../communities/components/RequestCommunityMembership";
import CommunityManagementHome from "../../communities/components/CommunityManagementHome";
import CommunityMembershipsOverview from "../../communities/components/CommunityMembershipsOverview";
import CommunityManagementMembershipDetails from "../../communities/components/CommunityManagementMembershipDetails";
import CommunityManagementMembershipDetailsHistory
  from "../../communities/components/CommunityManagementMembershipDetailsHistory";

const httpService = HttpService.Instance;
const drawerWidth = 260;

const styles: StyleRulesCallback = (theme: any) => ({
  toolbar: theme.mixins.toolbar,
  root: {
    flexGrow: 1,
    minHeight: "100vh",
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
  behind: {
    zIndex: 0
  },
  flexColumnContainter: {
    display: 'flex',
    flexDirection: 'column',
    zIndex: 0
  },
  drawerPaper: {
    height: "100%",
    width: drawerWidth,
    flex: 1,
    [theme.breakpoints.up('md')]: {
      position: 'relative',
    },
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
  fullHeight: {
    height: '100%'
  },
});

interface IState {
  mobileOpen: boolean,
  user: OrganizationUser | null,
  showAddressForm: boolean,
  isSingleUserEntity: boolean,
}

export class App extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      mobileOpen: false,
      user: null,
      showAddressForm: false,
      isSingleUserEntity: false
    };
  }

  public componentDidMount() {
    store.dispatch(loadCommunityOwnerships());
    this.getProfile();
  }

  public getProfile = async () => {
    const getUserResponse = await httpService.get(`${process.env.REACT_APP_API_URL}userprofile/`, { disableErrorMessageing: true });
    const userProfile = await getUserResponse.json();

    let showAddressForm = false;
    let isSingleUserEntity = false;

    if (userIsAdmin) {
      const entityId = identity['nxt:entity:id'];
      const getEntityResponse = await httpService.get(`${process.env.REACT_APP_API_URL}entity/${entityId}`);
      const entity: Entity = await getEntityResponse.json();
      isSingleUserEntity = entity.isSingleUserEntity;

      if (!entity.isSingleUserEntity && !this.entityHasValidBillingAddress(entity)) {
        showAddressForm = true;
      }
    }

    this.setState({
        user: userProfile,
        isSingleUserEntity,
        showAddressForm
      }
    );
  }

  public entityHasValidBillingAddress(entity: any){
    return entity.addresses.some((address: Address) =>
        address.addressTypeId === AddressTypeIds.Billing &&
        (address.street && address.street.length > 0) &&
        (address.city && address.city.length > 0) &&
        (address.country && address.country.length > 0) &&
        (address.postalCode && address.postalCode.length > 0)
    );
  }
  
  public handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  public render() {
    const { classes, theme } = this.props;
    const showCommunitiesLink = this.props.communityOwnerships && this.props.communityOwnerships.length > 0;
    let disableNavigation = false;
    if (
      window.location.pathname === '/request-subscription'
      || window.location.pathname === '/request-subscription-confirmation'
      || window.location.pathname === '/request-community-membership'
    ) {
      disableNavigation = true
    }
    if (this.state.showAddressForm) { disableNavigation = true }
    return (
      <Router history={history}>
        <div>
          <CssBaseline />
          <NavTop disableNavigation={disableNavigation} menuToggleHandler={this.handleDrawerToggle} user={this.state.user} />
          { this.checkTerms() &&
            <TermsAndConditionsForm getProfile={this.getProfile} />
          }
          {this.state.showAddressForm &&
            <BillingAdressForm callback={this.getProfile}/>
          }
          {!this.state.showAddressForm && !this.checkTerms() &&
            <div className={classes.root}>
              {!disableNavigation &&
                <Hidden mdUp={true}>
                  <Drawer
                    variant="temporary"
                    anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                    open={this.state.mobileOpen}
                    onClose={this.handleDrawerToggle}
                    classes={{
                      paper: classes.drawerPaper
                    }}
                    ModalProps={{
                      keepMounted: true, // Better open performance on mobile.
                    }}
                  >
                    <NavSide showCommunitiesLink={showCommunitiesLink} />
                  </Drawer>
                </Hidden>
              }
              {!disableNavigation &&
                <Hidden smDown={true}>
                  <div className={classes.flexColumnContainter}>
                    <div className={classes.toolbar} />
                    <Drawer
                      variant="permanent"
                      open={true}
                      className={classes.fullHeight}
                      classes={{
                        paper: classes.drawerPaper
                      }}
                    >
                      <NavSide showCommunitiesLink={showCommunitiesLink} />
                    </Drawer>
                  </div>
                </Hidden>
              }
              <main className={classes.content}>
                <Snackbar
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  open={this.props.openFeedbackMessage}
                  autoHideDuration={5000}
                  onClose={this.props.closeFeedbackMessageAction}
                >
                  <ValidationSnackbarContentWrapper
                    onClose={this.props.closeFeedbackMessageAction}
                    variant={this.props.feedbackMessageVariant}
                    message={<span id="message-id">{this.props.feedbackMessage}</span>}
                  />
                </Snackbar>
                <div className={classes.toolbar} />
                <Switch>
                  <Route exact={true} path='/' render={(props) => <Dashboard {...props} showCommunitiesLink={showCommunitiesLink} />} />
                  <Route path='/profile' component={MyProfile} />
                  <Route exact={true} path='/providerassets' component={ProviderAssets} />
                  <Route path='/providerassets/:assetid/:tab' component={ProviderAssetOverview} />
                  <Route exact={true} path='/subscriptions' component={Subscriptions} />
                  <Route path='/subscriptions/:assetid/:environment/:tab' component={ConsumerAssetOverview} />
                  <Route path='/organization/:tab' children={(props) => <OrganizationOverview {...props} />} />
                  <Route path='/organization' component={OrganizationOverview} />
                  <Route exact={true} path='/verifications' component={Verifications} />
                  <Route path='/verifications/:verificationId' component={Verification} />
                  <Route path='/subscriptiondetails/:verificationId' component={Verification} />
                  <Route path='/verification-history/:assetid/:subscriptionId' component={VerificationHistory} />
                  <Route path='/pending-subscriptions/:live' component={PendingSubscriptions} />
                  <Route path='/asset-subscriptions/:live/:asset' component={AssetSubscriptions} />
                  <Route path='/request-subscription' render={(props) => 
                      (<Subscribe {...props} isSingleUserEntity={this.state.isSingleUserEntity} />)} 
                  />
                  <Route path='/request-subscription-confirmation' component={SubscribeRequestConfirm} />
                  <Route path='/billing' component={Billing} />
                  <Route exact={true} path='/community-management' component={CommunityManagementHome} />
                  <Route exact={true} path='/community-management/:communityCode/memberships' component={CommunityMembershipsOverview} />
                  <Route exact={true} path='/community-management/:communityCode/memberships/:nxtEntityId' component={CommunityManagementMembershipDetails} />
                  <Route path='/community-management/:communityCode/memberships/:nxtEntityId/history' component={CommunityManagementMembershipDetailsHistory} />
                  <Route path='/request-community-membership' component={RequestCommunityMembership}/>
                  <Route path='/error/:code/:message' component={Error} />
                  <Route path='/expired' component={Expired} />
                  <Route path="*" component={Error} />
                </Switch>
              </main>
            </div>
          }
        </div>
      </Router>
    );
  }
  private checkTerms (){
    return this.state.user && this.state.user.termsAndConditionsTarget && this.state.user.termsAndConditionsVersion !== this.state.user.termsAndConditionsTarget
  }
}
const mapStateToProps = (state: any) => {
  return {
    feedbackMessage: state.snackbarState.feedbackMessage,
    feedbackMessageVariant: state.snackbarState.feedbackMessageVariant,
    openFeedbackMessage: state.snackbarState.openFeedbackMessage,
    communityOwnerships: state.communitiesReducer.communityOwnerships
  }
}
const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ closeFeedbackMessageAction, loadCommunityOwnershipsSuccess }, dispatch)
}
export default compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps)
)(App)


// WEBPACK FOOTER //
// ./src/modules/core/pages/App.tsx